import { z } from 'zod';

import { validateOrganisation } from './index.js';

/**
 * The stored shape of the `organisation` namespace (DEV-139): exactly the nine
 * fields, every one present, and the value must pass the same rules a save
 * does (validateOrganisation: the 70-character legal name, the disclosure
 * placeholders and length, currencies, time zone, support email). A stored
 * value that does not is refused by every reader, so nothing prints guessed
 * wording.
 */
export const organisationSchema = z.object({
  legalName: z.string(),
  registrationNumber: z.string(),
  addressLines: z.array(z.string()),
  statementDisclosures: z.array(z.string()),
  baseCurrency: z.string(),
  reportingCurrency: z.string(),
  timeZone: z.string(),
  paymentCutoff: z.string(),
  supportEmail: z.string(),
}).strict().superRefine((value, ctx) => {
  const checked = validateOrganisation(value);
  if (!checked.ok) {
    for (const [field, message] of Object.entries(checked.errors)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: [field], message: message ?? 'invalid' });
    }
  }
});
